import { createRouter, createWebHistory } from 'vue-router';

import CrearReceta from './views/CrearReceta.vue';
import CrearPaciente from './views/CrearPaciente.vue';
import VerPacientes from './views/VerPacientes.vue';
import VerRecetas from './views/VerRecetas.vue';
import VerExpediente from './views/VerExpediente.vue';
import CrearNota from './views/CrearNota.vue';
import SettingsPractitioner from './views/SettingsPractitioner.vue';
import CrearPracticante from './views/CrearPracticante.vue';
import PageNotFound from './layouts/page-not-found.vue';
import UnauthorizedAccess from './layouts/unauthorized.vue';
import VerPracticantes from './views/VerPracticantes.vue';
import VerPracticante from './views/VerPracticante.vue';
import VerHistoriaClinica from './views/VerHistoriaClinica.vue';
import IniciarSesion from './views/IniciarSesion.vue';
import CrearDiagnostico from './views/CrearDiagnostico.vue';
import ConsultasRecientes from './views/ConsultasRecientes.vue';
import VerSucursales from './views/VerSucursales.vue';
import EditarSucursales from './views/EditarSucursales.vue';
import IniciarAuditoria from '@/views/audit/IniciarAuditoria.vue';
import VerPacientesAudit from '@/views/audit/VerPacientesAudit.vue';
import VerExpedienteAudit from '@/views/audit/VerExpedienteAudit.vue';
import keycloak from '@/keycloak';
import { closeSession, authPromise } from '@/main';

const routes = [
    {
        path: '/',
        name: 'Login',
        component: IniciarSesion,
        meta: { noAuth: true },
    },

    // --- Rutas para Medicoes ---
    {
        path: '/crearPaciente/:id?',
        name: 'CrearPaciente',
        component: CrearPaciente,
        meta: { roles: ['Medico', 'Administrador'] },
    },
    {
        path: '/crearReceta/:id?',
        name: 'CrearReceta',
        component: CrearReceta,
        props: true,
        meta: { roles: ['Medico', 'Administrador'] },
    },
    {
        path: '/verRecetas',
        name: 'VerRecetas',
        component: VerRecetas,
        meta: { roles: ['Medico', 'Administrador'] },
    },
    {
        path: '/pacientes',
        name: 'Pacientes',
        component: VerPacientes,
        props: true,
        meta: { roles: ['Medico', 'Administrador'] },
    },
    {
        path: '/verExpediente/:id',
        name: 'Expediente',
        component: VerExpediente,
        props: (route) => ({ patientId: route.params.id }),
        meta: { roles: ['Medico', 'Administrador'] },
    },
    {
        path: '/verDiagnosticos/:id',
        name: 'Diagnosticos',
        component: VerHistoriaClinica,
        props: true,
        meta: { roles: ['Medico', 'Administrador'] },
    },
    {
        path: '/crearDiagnostico/:id',
        name: 'CrearDiagnostico',
        component: CrearDiagnostico,
        meta: { roles: ['Medico', 'Administrador'] },
    },
    {
        path: '/crearNota/:id',
        name: 'CrearNota',
        component: CrearNota,
        meta: { roles: ['Medico', 'Administrador'] },
    },
    {
        path: '/settingsPractitioner',
        name: 'SettingsPractitioner',
        component: SettingsPractitioner,
        meta: { roles: ['Medico', 'Administrador'] },
    },
    {
        path: '/consultasRecientes',
        name: 'ConsultasRecientes',
        component: ConsultasRecientes,
        meta: { roles: ['Medico', 'Administrador'] },
    },

    // --- Rutas de Administración ---
    {
        path: '/admin',
        name: 'VerPracticantes',
        component: VerPracticantes,
        meta: { roles: ['Administrador'] },
    },
    {
        path: '/admin/crearPracticante/:id?',
        name: 'CrearPracticante',
        component: CrearPracticante,
        meta: { roles: ['Administrador'] },
    },
    {
        path: '/admin/practicante/:id',
        name: 'Practicante',
        component: VerPracticante,
        meta: { roles: ['Administrador'] },
    },
    {
        path: '/admin/sucursales',
        name: 'VerSucursales',
        component: VerSucursales,
        meta: { roles: ['Administrador'] },
    },
    {
        path: '/admin/sucursal/:id',
        name: 'EditarSucursales',
        component: EditarSucursales,
        meta: { roles: ['Administrador'] },
    },

    // --- Rutas de Auditoría ---
    {
        path: '/audit/iniciarAuditoria',
        name: 'StartAudit',
        component: IniciarAuditoria,
        meta: { roles: ['Medico'] },
    },
    {
        path: '/audit/verPacientes',
        name: 'AuditPatients',
        component: VerPacientesAudit,
        meta: { roles: ['Medico'] },
    },
    {
        path: '/audit/verExpediente/:id',
        name: 'AuditExpediente',
        component: VerExpedienteAudit,
        props: (route) => ({ patientId: route.params.id }),
        meta: { roles: ['Medico'] },
    },

    // --- Errores ---
    { path: '/:pathMatch(.*)*', name: '404', component: PageNotFound },
    { path: '/401', name: '401', component: UnauthorizedAccess },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const ROLE_HOME_ROUTES = {
    Administrador: { name: 'VerPracticantes' },
    Medico: { name: 'Pacientes' },
    // Auditor: { name: 'VerRecetas' }
};

// --- Funciones auxiliares ---
function getUserRoles() {
    try {
        return JSON.parse(localStorage.getItem('roles') || '[]');
    } catch (error) {
        console.error('Error parsing roles:', error);
        return [];
    }
}

function isAuthenticated() {
    const roles = getUserRoles();
    if (roles.includes('Administrador')) return true;
    return !!localStorage.getItem('number');
}

function isBeingAudited() {
    return localStorage.getItem('isBeingAudited') === 'true';
}

function getHomeRouteByRole(roles) {
    const validRole = roles.find((role) => ROLE_HOME_ROUTES[role]);
    console.log('uno', validRole);
    if (validRole) return ROLE_HOME_ROUTES[validRole];

    return { path: '/' };
}

// --- Guard Global ---
router.beforeEach(async (to, from, next) => {
    try {
        if (authPromise) await authPromise;

        const remaining = keycloak.tokenParsed?.exp * 1000 - Date.now();
        if (remaining <= 0) {
            await closeSession();
            return;
        }

        const roles = getUserRoles();
        const isAuthenticatedUser = isAuthenticated();
        const requiredRoles = to.meta?.roles;
        const isPublicRoute = to.meta?.noAuth;
        const isAuditRoute = to.path.startsWith('/audit/');
        const isStartAuditRoute = to.path === '/audit/iniciarAuditoria';

        if (!isAuthenticatedUser && !isPublicRoute) {
            return next({ name: 'Login' });
        }

        if (isBeingAudited() && !isAuditRoute) {
            return next({ name: 'AuditPatients' });
        }

        if (!isBeingAudited() && isAuditRoute && !isStartAuditRoute) {
            return next({ name: 'Pacientes' });
        }

        // Si está autenticado pero no tiene los roles requeridos
        if (requiredRoles && requiredRoles.length > 0) {
            const hasRequiredRole = requiredRoles.some((role) =>
                roles.includes(role),
            );
            if (!hasRequiredRole) {
                return next({ name: '401' });
            }
        }

        // Redirección desde la raíz
        if (to.path === '/' && isAuthenticatedUser) {
            const homeRoute = getHomeRouteByRole(roles);
            if (to.name !== homeRoute.name) {
                return next(homeRoute);
            }
        }

        next();
    } catch (error) {
        console.error('Error en guard de navegación:', error);
        next({ name: 'Login' });
    }
});

export default router;
